import Vue from "vue";
import VueI18n from "vue-i18n";
import i18n from "@/modules/i18n";
import { Dictionary } from "@/types";

export function useOverride() {
  const origTC = i18n.tc;

  function pluralizationWrapper(
    this: any,
    key: VueI18n.Path,
    choice: VueI18n.Choice = 1,
    valuesOrLocale?: VueI18n.Locale | VueI18n.Values,
    values?: VueI18n.Values
  ): string {
    let tcFunc = origTC.bind(i18n) as (...args: any) => string;

    const getVal = (values: VueI18n.Values) => {
      let val: Dictionary<string> = { word: key };
      if (Array.isArray(values)) {
        values.forEach((item, index) => {
          val[index] = item;
        });
      } else {
        val = { ...val, ...values };
      }
      return val;
    };

    const vowels = "aeiou";
    const getChangedKey = (key: VueI18n.Path) => {
      let updatedKey = key;
      if (key.endsWith("y") && key.length >= 2 && !vowels.includes(key[key.length - 2])) {
        updatedKey = key.replace(/y$/, "ie");
      }
      return updatedKey;
    };
    let result;
    if (valuesOrLocale === undefined && values === undefined) {
      result = tcFunc("pl.word", choice, { word: getChangedKey(key) });
    } else if (typeof valuesOrLocale === "string" && valuesOrLocale === "no_number") {
      result = tcFunc("pl_no_number.word", choice, { word: getChangedKey(key) });
    } else if (typeof valuesOrLocale === "string") {
      result = tcFunc(key, choice, valuesOrLocale, getVal(values || {}));
    } else {
      result = tcFunc("pl.word", choice, getVal(valuesOrLocale || {}));
    }

    if (valuesOrLocale === "no_number") {
      result = i18n.t(result) as string;
    } else {
      const words = result.split(" ", 1);
      const translatedKey = i18n.t(result.replace(words[0] + " ", ""));
      result = words[0] + " " + translatedKey;
    }

    return result;
  }
  i18n.tc = Vue.prototype.$tc = pluralizationWrapper;
}

export const $t = (key: string, values?: any[] | Record<string, any>) => i18n.t(key, values) as string;
